/**
 * Management accounting reports
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 */


import ApiClient from '../ApiClient';





/**
* The Period model module.
* @module model/Period
* @version 1.0.0
*/
export default class Period {
    /**
    * Constructs a new <code>Period</code>.
    * Период отчета
    * @alias module:model/Period
    * @class
    * @param start {Date} 
    * @param end {Date} 
    */

    constructor(start, end) {
        

        
        

        this['start'] = start;this['end'] = end;

        
    }

    /**
    * Constructs a <code>Period</code> from a plain JavaScript object, optionally creating a new instance.
    * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
    * @param {Object} data The plain JavaScript object bearing properties of interest.
    * @param {module:model/Period} obj Optional instance to populate.
    * @return {module:model/Period} The populated <code>Period</code> instance.
    */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new Period();

            
            
            

            if (data.hasOwnProperty('start')) {
                obj['start'] = ApiClient.convertToType(data['start'], 'Date');
            }
            if (data.hasOwnProperty('end')) {
                obj['end'] = ApiClient.convertToType(data['end'], 'Date');
            }
        }
        return obj;
    }

    /**
    * @member {Date} start
    */
    start = undefined;
    /**
    * @member {Date} end
    */
    end = undefined;








}


